// src/config/LogoDisplay.jsx
import React from "react";
import { Link } from "react-router-dom";
import BRAND_LOGO from "../assets/branding/Collavue.png";
import { BRAND_NAME } from "./branding";

const SIZES = {
  sm: { img: "h-7", text: "text-sm" }, // ~28px
  md: { img: "h-9", text: "text-base" }, // ~36px
  lg: { img: "h-11", text: "text-lg" }, // ~44px
  xl: { img: "h-12 md:h-14", text: "text-xl" }, // 48→56px
  xxl: { img: "h-20 md:h-18 w-18 ", text: "text-2xl" }, // 56→64px
};

export default function LogoDisplay({
  directTo = "/",
  showWordmark = true,
  size = "xl", // default bumped from "md" → "xl"
  className = "",
}) {
  const { img, text } = SIZES[size] ?? SIZES.xl;

  return (
    <Link
      to={directTo}
      aria-label={BRAND_NAME}
      className={`group inline-flex items-center gap-3 rounded-md outline-none focus-visible:ring-2 focus-visible:ring-primary/40 ${className}`}
    >
      <img
        src={BRAND_LOGO}
        alt={BRAND_NAME}
        className={`${img} block object-contain select-none opacity-95 w-20 h-20 transition-opacity duration-150 group-hover:opacity-100`}
        loading="eager"
        decoding="async"
        draggable="false"
      />
      {showWordmark && (
        <span
          className={`${text} font-semibold leading-none tracking-tight text-slate-900 dark:text-white`}
        >
          {BRAND_NAME}
        </span>
      )}
    </Link>
  );
}
